import React from 'react';
import { CostItem } from '../CostItem';
export const SellingPrice = ({ value, autoAdjusted }) => {
    return (React.createElement(CostItem, { name: autoAdjusted ? 'Auto-adjusted selling price' : 'Selling price', value: value }));
};
